import { isEmpty } from ".";
import { getPath } from "../../../utils";

export const isFieldEditable = (field, data, prefixKey = "basic_details") => {
  return getPath(data, `${prefixKey}.` + field + ".editable", true);
};

export const isAnyStepRejected = (
  qcDetails,
  keys = [],
  prefixKey = "basic_details"
) => {
  return keys.some((field) => {
    const verified = getPath(
      qcDetails,
      `${prefixKey}.` + field?.key + ".verified",
      null
    );
    return verified === false;
  });
};

export const isActionDoneOnAllStepsOrRejectedAtleastOne = (
  qcDetails,
  keys = [],
  prefixKey = "basic_details"
) => {
  let isRejected = false;
  let isAllDone = true;

  for (let i = 0; i < keys.length; i++) {
    const field = keys[i];
    const verified = getPath(
      qcDetails,
      prefixKey + "." + field.key + ".verified",
      null
    );
    const autoVerified = getPath(
      qcDetails,
      prefixKey + "." + field.key + ".auto_verify",
      null
    );

    if (verified === false) {
      isRejected = true;
      break;
    }

    if (verified === null && autoVerified !== true) isAllDone = false;
  }

  return isRejected || isAllDone;
};

export const isActionDoneOnAllAboveSteps = (
  qcDetails,
  keys = [],
  currentKey
) => {
  const currIdx = keys.findIndex((field) => field.key === currentKey);

  return keys.slice(0, currIdx).every((field) => {
    const verified = getPath(
      qcDetails,
      "basic_details." + field.key + ".verified",
      null
    );
    const autoVerified = getPath(
      qcDetails,
      "basic_details." + field.key + ".auto_verify",
      null
    );

    return !isEmpty(verified) || autoVerified;
  });
};

export const isAllApproved = (
  qcDetails,
  keys = [],
  prefixKey = "basic_details"
) => {
  return keys.every((field) => {
    const verified = getPath(
      qcDetails,
      `${prefixKey}.` + field?.key + ".verified",
      false
    );
    const autoVerified = getPath(
      qcDetails,
      `${prefixKey}.` + field?.key + ".auto_verify",
      false
    );

    return verified || autoVerified;
  });
};

export const getRejectedStep = (
  qcDetails,
  keys = [],
  prefixKey = "basic_details"
) => {
  const key = keys.find((field) => {
    const verified = getPath(
      qcDetails,
      `${prefixKey}.` + field.key + ".verified",
      null
    );

    return verified === false;
  });

  return getPath(qcDetails, `${prefixKey}.` + key?.key, {});
};
